import{useRef as e}from"react";function useDerivedRef(r){const t=e(r);return t.current=r,t}export{useDerivedRef as default};
//# sourceMappingURL=useDerivedRef.js.map
